module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_21.771fc69a.mp3";